import { Box, Container, Typography } from "@mui/material";
import LandingRichText from "./LandingRichText";
import { checkIfContentEmpty } from "../../utils/tiptap";
import { LANDING_BRAND } from "./landingBrand";

type StudyPurposeContent = {
  badge?: string;
  title?: string;
  description?: string;
};

type Props = {
  data?: StudyPurposeContent;
};

const hasContent = (data?: StudyPurposeContent) => {
  if (!data) {
    return false;
  }
  if (data.badge?.trim() || data.title?.trim()) {
    return true;
  }
  return Boolean(data.description?.trim() && !checkIfContentEmpty(data.description));
};

const StudyPurposeSection = ({ data }: Props) => {
  if (!hasContent(data)) {
    return null;
  }

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, md: 10 },
        backgroundColor: "#fff",
      }}
    >
      <Container
        sx={{
          maxWidth: {
            xs: "100%",
            md: "60%",
          },
        }}
      >
        <Box sx={{ textAlign: "center" }}>
          {data?.badge?.trim() && (
            <Typography
              variant="body1"
              fontWeight="regular"
              sx={{
                display: "inline-block",
                mb: 2,
                p: "4px 16px",
                borderRadius: 999,
                bgcolor: LANDING_BRAND.primaryLight,
                color: LANDING_BRAND.primaryDark,
                lineHeight: "1.25rem",
              }}
            >
              {data.badge}
            </Typography>
          )}
          {data?.title?.trim() && (
            <Typography
              sx={{
                mb: 3,
                fontSize: { xs: "1.875rem", md: "2.25rem" },
                fontWeight: "bold",
                color: "text.primary",
                lineHeight: "2.5rem",
              }}
            >
              {data.title}
            </Typography>
          )}
          <LandingRichText
            html={data?.description}
            sx={{
              fontSize: "1.25rem",
              color: "#4B5563",
              lineHeight: "1.75rem",
              // maxWidth: "48rem",
              mx: "auto",
              textAlign: "center",
              "& p": { margin: "0 0 0.75rem", color: "inherit" },
              "& p:last-child": { marginBottom: 0 },
              "& ul, & ol": {
                margin: "0.5rem auto",
                paddingLeft: "1.5rem",
                textAlign: "left",
                display: "inline-block",
              },
              "& a": { color: LANDING_BRAND.primaryDark },
            }}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default StudyPurposeSection;
